const host = window.location.host;

export const isDev = /(127.0.0.1)|(localhost)|([0-1]?\d{1,2}\.[0-2]?\d{1,2}\.[0-2]?\d{1,2}\.[0-2]?\d{1,2}):/.test(host);

const matchResult = host.match(/www-([^-]+)-dx/);
export const envIdentifier = matchResult ? matchResult[1] : 'kaixue';
export const isProd = process.env.NODE_ENV == 'production';
export const isShip = process.env.CI_FE_DEBUG && process.env.CI_FE_DEBUG === 'true';
export const ua: string = window && window.navigator ? window.navigator.userAgent : '';
export const isInWakeup = ua ? /wakeup/i.test(ua) : false; // wakeup

export const cuid =
  ua.split('_cuid/')?.[1]?.split(' ')?.[0] || (isDev ? '4da3d7d542a4da2f387bf8400e4f2b8918ab754e' : '');

export const passportHost = (isLogin?: boolean): string => {
  if (isShip) {
    if (!isLogin) {
      return 'https://passport-base-dx.suanshubang.cc';
    }
    return 'https://passport-base-dx.suanshubang.com';
  }
  if (isProd) {
    return 'https://passport.daxuesoutijiang.com';
  }
  return 'https://passport-base-dx.suanshubang.com';
};

export const getEnv = (): string => {
  if (isShip) {
    return 'ship';
  }
  if (isDev) {
    return 'dev';
  }

  return 'online';
};
